module.exports = __webpack_public_path__ + "img/man_white.ea7e8c76.svg";